export default "__VITE_ASSET__B21o4cid__"